// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class DocumentParentLinkModel {
    static getAttributeTypeMap() {
        return DocumentParentLinkModel.attributeTypeMap;
    }
}
DocumentParentLinkModel.discriminator = undefined;
DocumentParentLinkModel.additionalProperties = false;
DocumentParentLinkModel.attributeTypeMap = [
    {
        "name": "parentDocumentId",
        "baseName": "parentDocumentId",
        "type": "number"
    },
];
//# sourceMappingURL=documentParentLinkModel.js.map